import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Modal, Form, DatePicker, message } from "antd";
import { createAccountingPeriod, closeAccountingPeriod } from "../../../actions/accountingClosingAction";

const CreateClosing = ({ createAccountingPeriod, closeAccountingPeriod, setreload }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const payload = {
        start_date: values.start_date.format("YYYY-MM-DD"),
        end_date: values.end_date.format("YYYY-MM-DD"),
      };

      const newPeriod = await createAccountingPeriod(payload);
      if (newPeriod && newPeriod.id) {
        const closed = await closeAccountingPeriod(newPeriod.id);
        if (closed) {
          setVisible(false);
          form.resetFields();
          setreload(true);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Validation Failed:", error);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setVisible(true)}>
        Close New Period
      </Button>

      <Modal
        title="Close Accounting Period"
        visible={visible}
        onOk={handleCreate}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical" name="closing_form">
          <Form.Item
            name="start_date"
            label="Start Date"
            rules={[{ required: true, message: "Please select start date!" }]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name="end_date"
            label="End Date"
            rules={[{ required: true, message: "Please select end date!" }]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default connect(null, { createAccountingPeriod, closeAccountingPeriod })(CreateClosing);
